/* TabHeader.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { breakpointValues, H4, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import React from 'react';
import { ContactPartnerSection } from '../ContactPartnerSection';
import { ExpandAllSectionsButton } from '../ExpandAllSectionsButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "@media (min-width:48rem){._zkhy1g80{flex-wrap:wrap}._1to9xjmg{row-gap:var(--ds-space-200)}}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1bah1yb4{justify-content:space-between}";
const _ = "._1e0c1txw{display:flex}";
export const Header = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bah1yb4 _4cvr1h6o _zkhy1g80 _1to9xjmg", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Header.displayName = 'Header';
}
export const TabHeader = _ref2 => {
  let {
    isEmptyState,
    contactPartnerLinkProps
  } = _ref2;
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isTabletOrDesktopDevice = breakpoint >= breakpointValues.sm;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(Header, {
      children: [/*#__PURE__*/_jsx(H4, {
        as: "h2",
        children: " Privacy and Security details "
      }), isTabletOrDesktopDevice && /*#__PURE__*/_jsx(ExpandAllSectionsButton, {})]
    }), /*#__PURE__*/_jsx(ContactPartnerSection, {
      isEmptyState: isEmptyState,
      contactPartnerLinkProps: contactPartnerLinkProps
    })]
  });
};